import { CachePolicies, useFetch } from "use-http";

import { getConfig } from "config/config";

const config = getConfig();
const { JANZU_URL } = config;

export const usePostEvent = () => {
  const eventUrl = `${JANZU_URL}device-api/events`;
  const { post: postEvent } = useFetch(eventUrl, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  const sendErrorEvent = (endpoint: string) => {
    postEvent("", { event_type: "reef_retry_error", endpoint });
  };

  return { postEvent, sendErrorEvent };
};
